const Footer = () => {
  return (
    <footer className="bg-blue-dark text-white py-7 lg:pt-10 px-10 text-center lg:text-left lg:flex lg:flex-row-reverse justify-between items-center">
    <p className="mb-2 lg:mb-0"><a className="hover:underline" href="http://about.policymogul.com/terms-and-conditions/">Terms</a> <span className="mx-2">|</span> <a className="hover:underline" href="https://about.policymogul.com/privacy-policy/">Privacy</a></p>
      <p>© {new Date().getFullYear()} PolicyInfluence. All rights reserved.</p>
    </footer>
  )
}

export default Footer;